export default "__VITE_ASSET__4d891df8__"